import $api from "../http";
import { ICountry } from "../models/Country";

class CountryServiceClass {
  async getCountries() {
    return await $api.get<ICountry[]>("api/country");
  }
}

export const CountryService = new CountryServiceClass();
